export default __webpack_public_path__ + "static/social-envipe_en-dbb2ce2f7ca4aabeefdacb7949393463.png";